import styled from 'styled-components';
import { BdsPaper } from 'blip-ds/dist/blip-ds-react';
import { FadeIn } from '../../../components/Global/animations';

export const AdvancedDailyEngagedUserContainer = styled.div`
  grid-template-areas: 'sidebar content';
  grid-template-columns: 1fr 3fr;
  animation: ${FadeIn} ease-in 0.5s;
  animation-iteration-count: 1;
`;

export const AdvancedDailyEngagedUserPaper = styled(BdsPaper)`
  padding: 1.5rem;
  margin-bottom: 2rem;
  animation: ${FadeIn} ease-in 0.5s;
  animation-iteration-count: 1;

  > bds-typo + bds-typo {
    display: block;
    margin-top: 8px;
    margin-bottom: 24px;
  }

  table {
    table-layout: fixed;
    width: 100%;
  }

  table th:first-child,
  table td:first-child {
    white-space: normal;
    word-break: break-word;
    overflow: visible;
    text-overflow: unset;
  }
`;

export const CompiledAdvancedDailyEngagedUsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 80px;
  animation: ${FadeIn} ease-in 0.5s;
`;

export const CompiledAdvancedDailyEngagedUserPaper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  padding: 24px 32px;

  background: #f6f6f6;
  box-shadow: 0px 2px 8px rgba(7, 71, 166, 0.15);
  border-radius: 8px;

  width: 100%;

  animation: ${FadeIn} ease-in 0.5s;
  animation-iteration-count: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e7edf4;
`;

export const MetricsGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
`;

export const MetricCardItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  padding: 24px;
  gap: 4px;

  background: #ededed;
  border-radius: 8px;

  min-height: 116px;
  flex: 1;

  & bds-typo {
    width: 100%;
    word-break: break-word;
  }
`;

